'use es6';

import PropTypes from 'prop-types';
import * as React from 'react';
import partial from 'react-utils/partial';
import memoizeOne from 'react-utils/memoizeOne';
import getComponentName from 'react-utils/getComponentName';
import omit from '../../utils/underscore/omit';
import { attachWrappedComponent } from '../../decorators/utils';
import * as SimpleDate from '../../core/SimpleDate';
import { jsx as _jsx } from "react/jsx-runtime";
const instancesForTz = {};
const todayForTz = {};
const intervalHandleForTz = {};
const updateToday = tz => {
  const oldToday = todayForTz[tz];
  const newToday = SimpleDate.now(tz);
  if (!oldToday || !SimpleDate.equals(oldToday, newToday)) {
    todayForTz[tz] = newToday;
    instancesForTz[tz].forEach(instance => instance.forceUpdate());
  }
};
const registerInstance = (instance, tz) => {
  if (!instancesForTz[tz]) instancesForTz[tz] = [];
  const instances = instancesForTz[tz];
  if (instances.length === 0) {
    updateToday(tz);
    intervalHandleForTz[tz] = setInterval(partial(updateToday, tz), 60e3);
  }
  instances.push(instance);
};
const unregisterInstance = (instance, tz) => {
  const instances = instancesForTz[tz].splice(instancesForTz[tz].indexOf(instance), 1);
  if (instances.length === 0) clearInterval(intervalHandleForTz[tz]);
};
const updateInstanceForTz = (instance, tz) => {
  if (instance.tz) {
    unregisterInstance(instance, instance.tz);
  }
  registerInstance(instance, tz);
  instance.tz = tz;
};
export default function UsesToday(Component) {
  class UsesTodayComponent extends React.Component {
    constructor(props) {
      super(props);
      this._updateInstanceForTz = memoizeOne(updateInstanceForTz);
      this._updateInstanceForTz(this, props.tz);
    }
    componentWillUnmount() {
      unregisterInstance(this, this.props.tz);
    }
    render() {
      const {
        tz
      } = this.props;
      this._updateInstanceForTz(this, tz);
      return /*#__PURE__*/_jsx(Component, Object.assign({
        today: todayForTz[tz]
      }, this.props));
    }
  }
  attachWrappedComponent(UsesTodayComponent, Component);
  UsesTodayComponent.displayName = `UsesToday(${getComponentName(Component)})`;
  UsesTodayComponent.propTypes = Object.assign({}, omit(Component.propTypes, 'today'), {
    tz: PropTypes.oneOf(['userTz', 'portalTz', 'utc']).isRequired
  });
  UsesTodayComponent.defaultProps = Object.assign({}, omit(Component.defaultProps, 'today'), {
    tz: 'userTz'
  });
  return UsesTodayComponent;
}

// Export hook for test reset
UsesToday.instancesForTz = instancesForTz;